/**
 * Full-screen loader: logo grows in width while the page loads, then slides down.
 */

import { gsap } from 'gsap';

const LOGO_GROWTH_DURATION = 2;

function measureLogoWidth(logoWrap, logo) {
	const previousWidth = logoWrap.style.width;

	logoWrap.style.width = 'auto';
	const width = logoWrap.offsetWidth;

	logoWrap.style.width = previousWidth || '0';

	return width;
}

export function initSiteLoader() {
	const loader = document.getElementById('site-loader');
	if (!loader) {
		return;
	}

	const logoWrap = loader.querySelector('.site-loader__logo-wrap');
	const logo = loader.querySelector('.site-loader__logo');

	if (!logoWrap || !logo) {
		return;
	}

	document.documentElement.classList.add('has-site-loader');

	const startGrowth = () => {
		const targetWidth = measureLogoWidth(logoWrap, logo);

		if (!targetWidth) {
			return;
		}

		gsap.set(logoWrap, { width: 0 });

		const growth = { value: 0 };

		let pageLoaded = document.readyState === 'complete';
		let logoGrowthComplete = false;
		let exitStarted = false;

		const tryExit = () => {
			if (exitStarted || !pageLoaded || !logoGrowthComplete) {
				return;
			}

			exitStarted = true;
			window.dispatchEvent(new CustomEvent('zlc:site-loader-complete'));

			gsap.to(loader, {
				yPercent: 100,
				duration: 0.9,
				ease: 'power2.inOut',
				delay: 0.2,
				onComplete: () => {
					loader.remove();
					document.documentElement.classList.remove('has-site-loader');
				},
			});
		};

		gsap.to(growth, {
			value: 1,
			duration: LOGO_GROWTH_DURATION,
			ease: 'none',
			onUpdate: () => {
				logoWrap.style.width = `${growth.value * targetWidth}px`;
			},
			onComplete: () => {
				logoWrap.style.width = `${targetWidth}px`;
				logoGrowthComplete = true;
				tryExit();
			},
		});

		const onPageLoad = () => {
			pageLoaded = true;
			tryExit();
		};

		if (pageLoaded) {
			onPageLoad();
		} else {
			window.addEventListener('load', onPageLoad, { once: true });
		}
	};

	if (logo.complete) {
		startGrowth();
	} else {
		logo.addEventListener('load', startGrowth, { once: true });
		logo.addEventListener('error', startGrowth, { once: true });
	}
}
